<template>
  <tbody
    class="ticket-row"
    :class="{
      'ticket-row--finished': isFinished,
      'ticket-row--cancelled': isCancelled,
    }"
  >
    <tr>
      <td>
        <div class="order-number">{{ ticket.order_number }}</div>
        <div v-if="fromWebsite" class="web-badge">Website</div>
      </td>
      <td>{{ placeLabel }}</td>
      <td>
        <template v-if="ticket.guest && ticket.guest.name">
          <div>{{ ticket.guest.name }}</div>
          <div v-if="ticket.guest.phone" class="ticket-row__phone">
            {{ ticket.guest.phone }}
          </div>
        </template>
        <template v-else>—</template>
      </td>
      <td>
        <div v-if="ticketLineItems.length" class="ticket-row__items">
          <div v-for="(row, idx) in ticketLineItems" :key="idx">
            <span class="ticket-row__item-name">{{ row.dish_name }}</span>
            <span class="ticket-row__item-meta">
              {{ row.unit_label }} · {{ row.quantity }}
            </span>
          </div>
        </div>
        <span v-else>—</span>
      </td>
      <td>
        <div v-if="ticket.status === 'cancelled'" class="status-badge cancelled">
          Cancelled
        </div>
        <div v-else class="status-badge" :class="ticket.kitchen_status">
          {{ ticket.kitchen_status.replace('_', ' ').toUpperCase() }}
        </div>
      </td>
      <td>
        <div class="ticket-actions">
      <button
        type="button"
        class="action-btn print"
        aria-label="Kitchen ticket print"
        v-tooltip.top-center="actionTip('Kitchen ticket print')"
        @click="GetSingleKitchenTickets(ticket.id, 'kot-modal-' + ticket.id)"
      >
        <i class="fa fa-print" aria-hidden="true"></i>
      </button>

      <button
        v-if="
          ticket.status !== 'cancelled' && ticket.kitchen_status === 'pending'
        "
        type="button"
        class="action-btn start"
        aria-label="Start preparing"
        v-tooltip.top-center="actionTip('Start preparing')"
        @click="updateKitchenStatus(ticket.id, 'preparing')"
      >
        <i class="fa fa-play" aria-hidden="true"></i>
      </button>

      <button
        v-if="
          ticket.status !== 'cancelled' && ticket.kitchen_status === 'preparing'
        "
        type="button"
        class="action-btn finish"
        aria-label="Mark finished"
        v-tooltip.top-center="actionTip('Mark finished')"
        @click="updateKitchenStatus(ticket.id, 'finished')"
      >
        <i class="fa fa-check" aria-hidden="true"></i>
      </button>

      <button
        type="button"
        class="action-btn customer"
        aria-label="Customer bill print"
        v-tooltip.top-center="actionTip('Customer bill print')"
        @click="GetSingleCustomerTickets(ticket.id, 'modal-' + ticket.id)"
      >
        <i class="fa fa-file-invoice" aria-hidden="true"></i>
      </button>

      <button
        v-if="ticket.status !== 'cancelled'"
        type="button"
        class="action-btn cancel"
        aria-label="Cancel bill"
        v-tooltip.top-center="actionTip('Cancel bill')"
        @click="
          GetSingleCustomerOrderCancel(ticket.id, 'cancel-modal-' + ticket.id)
        "
      >
        <i class="fa fa-trash" aria-hidden="true"></i>
      </button>
        </div>

    <!-- CUSTOMER MODAL -->
    <CModal
      Text="customize"
      :ref="'customerModal' + ticket.id"
      headerText="Customer Ticket"
      :width="450"
      submitText="Print"
      :hideButton="true"
      @onClickSubmit="PrintCustomerTicket"
      :visibleFooter="true"
      :modalName="'modal-' + ticket.id"
    >
      <template v-slot:content>
        <CustomerTicketsingleView
          :Order="TicketsSingleData"
          :TicketNumber="finalOutput"
          ref="Bills"
        />
      </template>
    </CModal>

    <!-- KOT MODAL -->
    <CModal
      Text="customize"
      :ref="'kotModal' + ticket.id"
      headerText="Kitchen Ticket"
      :width="450"
      submitText="Print"
      :hideButton="true"
      @onClickSubmit="PrintKitchenTicket"
      :visibleFooter="false"
      :modalName="'kot-modal-' + ticket.id"
    >
      <template v-slot:content>
        <div v-for="(item, index) in kotTicketNumber1" :key="item">
          <div class="kot-print-header" style="padding: 20px">
            <label>{{ computedVal(item).key }}</label>
            <button
              class="kot-print-btn"
              @click="
                PrintMethod(
                  index,
                  computedVal(item).data,
                  computedVal(item).key,
                )
              "
            >
              Print
            </button>
          </div>
          <KitchenTicketSingleView
            v-show="false"
            :Order="TicketsSingleData1"
            :OrderDetails="ticket"
            :TicketNumber="finalOutput1"
            ref="BillsKOT"
          />
        </div>
      </template>
    </CModal>

    <!-- CANCEL MODAL -->
    <CModal
      Text="customize"
      :ref="'CancelModal' + ticket.id"
      headerText="Cancel Order"
      :width="500"
      @onClickSubmit="makeOrderCancel"
      submitText="Cancel"
      :hideButton="true"
      :visibleFooter="true"
      :modalName="'cancel-modal-' + ticket.id"
    >
      <template v-slot:content>
        <div class="cancel-note">
          <label>Note</label>
          <input
            class="form-control"
            placeholder="Enter note"
            v-model="Ordercancel.note"
          />
        </div>
      </template>
    </CModal>
      </td>
    </tr>
  </tbody>
</template>

<script>
import {CustomModal as CModal} from '@/components/base/index.js';
import CustomerTicketsingleView from '../CustomerTicketsingles/index';
import KitchenTicketSingleView from '../KitchenTicketSingle/index';
import axios from '@/plugins/axios';

export default {
  name: 'CUSTOMERTICKETPRINTPREVIEW',
  props: {
    ticket: {type: Object, required: true},
    visibleButton: {type: Boolean, default: false},
  },
  data: () => ({
    Ordercancel: {note: '', status: 'cancelled'},
    OrderCancelData: [],
    TicketsSingleData1: [],
    TicketsSingleData: [],
    kotTicketNumber1: null,
    finalOutput: null,
    finalOutput1: null,
  }),
  components: {CModal, CustomerTicketsingleView, KitchenTicketSingleView},
  computed: {
    isCancelled() {
      return this.ticket.status === 'cancelled';
    },
    fromWebsite() {
      return String((this.ticket && this.ticket.note) || '').indexOf('Website pickup') === 0;
    },
    placeLabel() {
      if (this.ticket && this.ticket.table && this.ticket.table.name) {
        return this.ticket.table.name;
      }
      if (this.ticket && this.ticket.room && this.ticket.room.name) {
        return this.ticket.room.name;
      }
      return 'Takeaway';
    },
    isFinished() {
      return !this.isCancelled && this.ticket.kitchen_status === 'finished';
    },
    ticketLineItems() {
      const raw = this.ticket.items;
      if (!raw || !Array.isArray(raw)) return [];
      return raw.map(item => ({
        dish_name: item.dish_name || (item.dish && item.dish.name) || '',
        quantity: item.quantity,
        unit_label:
          item.unit_label ||
          (item.unit && (item.unit.sortform || item.unit.name)) ||
          '',
      }));
    },
  },
  methods: {
    actionTip(content) {
      return {
        content,
        classes: ['ticket-action-tooltip'],
        delay: { show: 80, hide: 40 },
        offset: 6,
      };
    },
    visibleHandler() {
      if (!this.visibleButton) this.visibleButton = !this.visibleButton;
    },
    PrintCustomerTicket() {
      const bills = this.$refs.Bills;
      const printer = Array.isArray(bills) ? bills[0] : bills;
      if (printer && typeof printer.print === 'function') printer.print();
    },
    GetSingleCustomerOrderCancel(orderId, modalName) {
      axios.get(`hms/web/orders/${orderId}`).then(res => {
        this.OrderCancelData = res.data.id;
        this.$refs['CancelModal' + orderId].show(modalName);
      });
    },
    GetSingleCustomerTickets(orderId, modalName) {
      axios
        .get(`hms/web/orders/${orderId}`)
        .then(res => {
          this.TicketsSingleData = res.data;
          const items = Array.isArray(res.data.items) ? res.data.items : [];
          const lastTicket = items.length
            ? items[items.length - 1].ticket_number
            : '';
          this.finalOutput = lastTicket
            ? lastTicket.substring(lastTicket.lastIndexOf('-') + 1)
            : '1';
          const modal = this.$refs['customerModal' + orderId];
          if (modal) modal.show(modalName);
        })
        .catch(() => {
          this.$fire({
            title: 'Error',
            text: 'Could not load order for customer bill',
            type: 'error',
            timer: 3000,
          });
        });
    },
    GetSingleKitchenTickets(orderId, modalName) {
      axios
        .get(`hms/web/orders/kot/${orderId}`)
        .then(res => {
          const kotItems = res.data && res.data.items ? res.data.items : {};
          const values = Object.keys(kotItems).map(key => ({[key]: kotItems[key]}));
          if (!values.length) {
            this.$fire({
              title: 'No kitchen tickets',
              text: 'No KOT lines found for this order.',
              type: 'info',
              timer: 3000,
            });
            return;
          }
          this.kotTicketNumber1 = values;
          this.$nextTick(() => {
            const modal = this.$refs['kotModal' + orderId];
            if (modal) modal.show(modalName);
          });
        })
        .catch(() => {
          this.$fire({
            title: 'Error',
            text: 'Could not load kitchen tickets',
            type: 'error',
            timer: 3000,
          });
        });
    },
    PrintKitchenTicket(index) {
      this.$nextTick(() => {
        const refs = this.$refs.BillsKOT;
        const bill = Array.isArray(refs) ? refs[index] : refs;
        if (bill && typeof bill.print === 'function') {
          bill.print();
        }
      });
    },
    PrintMethod(index, item, number) {
      this.TicketsSingleData1 = item;
      this.finalOutput1 = number
        ? number.substring(number.lastIndexOf('-') + 1)
        : '1';
      setTimeout(() => this.PrintKitchenTicket(index), 150);
    },
    makeOrderCancel() {
      if (!this.Ordercancel.note) {
        this.$fire({
          title: 'Error',
          text: 'Please Enter Note',
          type: 'error',
          timer: 3000,
        });
        return;
      }
      axios
        .patch(
          `hms/web/orders/${this.OrderCancelData}/change-status`,
          this.Ordercancel,
        )
        .then(() => {
          this.$fire({
            title: 'Success',
            text: 'Order Cancelled Successfully',
            type: 'success',
            timer: 3000,
          });
          this.OrderCancelData = null;
          this.Ordercancel.note = '';
          this.$refs['CancelModal' + this.ticket.id].hide();
          this.$emit('refresh');
        });
    },
    async updateKitchenStatus(orderId, kitchen_status) {
      try {
        await axios.patch(`hms/web/orders/${orderId}/kitchen-status`, {
          kitchen_status,
        });
        this.$emit('refresh');
      } catch (err) {
        console.error('Error updating kitchen status:', err);
        this.$fire({
          title: 'Error',
          text: 'Kitchen status update failed',
          type: 'error',
          timer: 3000,
        });
      }
    },
    computedVal(data) {
      const key = Object.keys(data)[0];
      return {key, data: data[key]};
    },
    statusIcon(status) {
      switch (status) {
        case 'pending':
          return 'fa fa-hourglass-half';
        case 'preparing':
          return 'fas fa-utensils';
        case 'finished':
          return 'fa fa-check-circle';
        case 'cancelled':
          return 'fa fa-times-circle';
        default:
          return 'fa fa-info-circle';
      }
    },
  },
};
</script>

<style scoped>
.order-header {
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 10px;
}

.order-details {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.order-number {
  font-weight: 700;
  color: #111827;
  font-size: 14px;
}

.order-table {
  font-size: 13px;
  color: #4f545e;
  margin-top: 2px;
}

.web-badge {
  display: inline-block;
  margin-top: 6px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #1d4ed8;
  background: #dbeafe;
  border-radius: 999px;
  padding: 2px 8px;
}

.order-guest {
  margin-top: 4px;
  font-size: 12px;
  color: #111827;
}

.ticket-line-items {
  width: 100%;
  margin: 8px 0 4px;
  font-size: 12px;
  color: #374151;
  border-top: 1px solid #e5e7eb;
  padding-top: 8px;
}
.line-items-head,
.line-items-row {
  display: grid;
  grid-template-columns: 1fr minmax(36px, auto) 28px;
  gap: 6px;
  align-items: start;
}
.line-items-head {
  font-weight: 600;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  color: #6b7280;
  margin-bottom: 4px;
}
.line-items-row {
  margin-bottom: 4px;
}
.line-items-row:last-child {
  margin-bottom: 0;
}
.ticket-line-items .col-item {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ticket-line-items .col-unit {
  text-align: center;
  color: #6b7280;
  white-space: nowrap;
}
.ticket-line-items .col-qty {
  text-align: right;
  font-weight: 600;
  color: #111827;
}

.status-badge {
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  font-size: 10px;
  font-weight: 700;
  padding: 2px 8px;
  border-radius: 20px;
  color: #c2410c;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  white-space: nowrap;
}

.status-badge.pending {
  background: #fff7ed;
  color: #fc9d17;
}
.status-badge.preparing {
  background: #fffadd;
  color: #fad817;
}

.status-badge.finished {
  background: #dcfce7;
  color: #166534;
}

.status-badge.cancelled {
  color: #b91c1c;
}

.ticket-card {
  background: #fff;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
  padding: 14px;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
}

.ticket-card--finished {
  background: #f8fafc;
  border-color: #dbeafe;
}

.ticket-card--cancelled {
  background: #fef2f2;
  border-color: #fecaca;
}

/* STATUS */
.ticket-status {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  font-weight: 600;
  text-transform: uppercase;
  font-size: 13px;
  margin-bottom: 8px;
}
.ticket-status i {
  font-size: 14px;
}
.status-pending {
  color: #ca8a04;
}
.status-preparing {
  color: #fad817;
}
.status-finished {
  color: #16a34a;
}
.status-cancelled {
  color: #dc2626;
}

/* ORDER INFO */
.order-type {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  color: #374151;
  text-transform: uppercase;
  font-weight: 600;
  gap: 6px;
}
.order-type i {
  font-size: 14px;
  color: #6b7280;
}

/* ACTION BUTTONS */
.ticket-row td {
  vertical-align: middle;
  padding: 6px 10px;
  border-bottom: 1px solid #e2e8f0;
  text-align: left;
  background: #ffffff;
  color: #0f172a;
  font-size: 13px;
}

.ticket-row--finished td {
  background: #f8fafc;
}

.ticket-row--cancelled td {
  background: #fef2f2;
}

.ticket-row__phone,
.ticket-row__item-meta {
  color: #64748b;
  font-size: 12px;
}

.ticket-row__items {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.ticket-row__item-name {
  font-weight: 600;
}

.ticket-row__item-meta {
  margin-left: 6px;
}

.ticket-actions {
  display: inline-flex;
  justify-content: flex-start;
  gap: 4px;
  width: auto;
  margin-top: 0;
}
.action-btn {
  border: none;
  outline: none;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background: #f3f4f6;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
}
.action-btn i {
  font-size: 12px;
}
.action-btn.print {
  background: var(--brand-primary-muted);
  color: var(--brand-primary-dark) !important;
}
.action-btn.customer {
  background: var(--brand-primary-muted);
  color: var(--brand-primary-dark) !important;
}
.action-btn.cancel {
  background: #fee2e2;
  color: #b91c1c !important;
}
.action-btn.start {
  background: #fff7ed;
  color: #c2410c !important;
}
.action-btn.finish {
  background: var(--brand-primary-muted);
  color: var(--brand-primary-dark) !important;
}

/* CANCEL MODAL NOTE */
.cancel-note {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 0;
}
.cancel-note label {
  font-weight: 600;
  width: 50px;
}

/* KOT PRINT HEADER */
.kot-print-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 8px 0;
}
.kot-print-header label {
  font-weight: 600;
  background: #e5e7eb;
  padding: 4px 8px;
  border-radius: 4px;
}
.kot-print-btn {
  background: var(--brand-primary);
  border: none;
  color: #fff;
  border-radius: 6px;
  padding: 4px 10px;
  cursor: pointer;
}
.kot-print-btn:hover {
  background: var(--brand-primary-hover);
}
</style>
